import { useLocation } from 'react-router-dom';

export const HOME_BASE_PATH = '/home';

export const DASHBOARD_BASE_PATH = '/dashboard';

export function useHomeBasePath(): string {
  const { pathname } = useLocation();

  return pathname.startsWith(HOME_BASE_PATH)
    ? HOME_BASE_PATH
    : DASHBOARD_BASE_PATH;
}
